/*
 * @Author: 代码尊 gaojianstyle@163.com
 * @Date: 2023-01-18 05:55:09
 * @LastEditors: gaojian
 * @LastEditTime: 2023-02-14 20:37:37
 * @FilePath: \g-vue3\src\router\index.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { createRouter, createWebHistory, createWebHashHistory, RouteRecordRaw } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'index',
    component: () => import("@/views/index.vue"),//底页
    redirect: '/',//页面默认加载的路由
    children: [
      {
        // 首页
        path: '/',
        component: () => import('@/views/indexCenter.vue'),
      },
      {
        // 用户收藏
        path: '/user/likes',
        component: () => import('@/views/UserLikes.vue'),
      },
      {
        // 分类列表
        path: '/categories',
        component: () => import('@/views/categories.vue'),
      },
      {
        //分类详情
        path: '/categoriesMsg',
        component: () => import('@/views/categoriesMsg.vue'),
      },
      {
        // 登录
        path: '/login',
        component: () => import('@/views/login.vue'),
      },
      {
        // 购物车
        path: '/cars',
        component: () => import('@/views/cars.vue'),
      },
      {
        // 订单详情
        path: '/order',
        component: () => import('@/views/order.vue'),
      },
      {
        // 商品详情
        path: '/products',
        component: () => import('@/views/products.vue'),
      },
      {
        // 注册页面
        path: '/register',
        component: () => import('@/views/register.vue'),
      },
      {
        // 找回密码
        path: '/reset',
        component: () => import('@/views/reset.vue'),
      },
    ]
  },
  {
    // 个人中心
    path: '/user',
    name: 'user',
    component: () => import("@/views/user.vue"),//底页
    redirect: '/userCenter',//页面默认加载的路由
    children: [
      {
        // 个人中心
        path: '/userCenter',
        component: () => import('@/views/userCenter.vue'),
      },
      {
        // 密码修改
        path: '/user/password',
        component: () => import('@/views/userPassword.vue'),
      },
      {
        // 个人资料
        path: '/user/setting',
        component: () => import('@/views/userSetting.vue'),
      },
      {
        // 收货地址
        path: '/user/address',
        component: () => import('@/views/userAddress.vue'),
      },
      {
        // 积分等级
        path: '/user/scores',
        component: () => import('@/views/userScores.vue'),
      },
      {
        // 订单管理
        path: '/user/order',
        component: () => import('@/views/userOrder.vue'),
      },
      {
        // 优惠券管理
        path: '/user/coupons',
        component: () => import('@/views/userCoupons.vue'),
      },
    ]
  },
  {
    path: '/demo',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  }
]

const router = createRouter({
  // /
  // history: createWebHistory(process.env.BASE_URL),
  // #
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})

export default router
